/**
 * Central React Query key factory. One source of truth per query so a key
 * shape only has to change in one place, and so an invalidation call can
 * reuse the exact prefix a query was registered under instead of
 * re-typing the string literal.
 */
export const queryKeys = {
	feed: {
		timeline: (isApp: boolean, lang: string) =>
			['widget-timeline', isApp, lang] as const,
		widget: (id: string, lang: string) => ['widget', id, lang] as const,
		/** Prefix shared by every widgetResults() key — invalidate on this to
		 * refetch a widget's results regardless of resultCount/isMobileFeed. */
		widgetResultsRoot: 'widget-results' as const,
		widgetResults: (
			widgetId: string,
			resultCount: number,
			isMobileFeed: boolean
		) =>
			[
				queryKeys.feed.widgetResultsRoot,
				widgetId,
				resultCount,
				isMobileFeed,
			] as const,
	},
	session: {
		profile: () => ['cityzens-profile'] as const,
		dictionary: (assetsApiUrl: string) =>
			['localization', 'cityzens', assetsApiUrl] as const,
	},
	layout: {
		footer: () => ['footer'] as const,
		mainNav: () => ['main-nav'] as const,
		partners: () => ['partners'] as const,
	},
};
